export default {
  pages: {
    appDownload: {
      title: 'Never miss out on the action!',
      subtitle:
        'Download the Splash Sports mobile app and turn on notifications to get pick reminders, the most up-to-date gameplay experience, social features, and additional payment methods!',
      downloadButton: 'Download the app',
      continueButton: 'Continue using mobile web',
      continueButtonWeb: 'Continue using web',
      contestPromoNote: 'We’ll bring you to your contest after downloading the app.',
    },
    notFound: {
      header: 'Not Found',
      title: 'Page not found',
      description:
        'The page you are trying to open does not exist. You may have mistyped the address, or the page has been moved to another URL. If you think this is an error, please <link>contact support</link>.',
      action: {
        home: 'Take me home',
        support: 'contact support',
      },
    },
    channelNotFound: {
      title: 'Channel failed to load',
      description: {
        myChannel: 'Refresh this page. If this issue persists, please contact support.',
        otherChannel:
          'Channel failed to load. Go back and try again, or refresh this page. If this issue persists, please contact support.',
      },
    },
    unknown: {
      header: 'Unknown error',
      title: 'Something went wrong',
      description:
        "Our servers could not handle your request. Don't worry, our development team was already notified. Try refreshing the page.",
      action: {
        reload: 'Reload the page',
      },
    },
    market: {
      title: 'Predict',
      tabs: {
        browse: 'Browse',
        myPositions: 'My Positions',
      },
    },
  },
  headerNavigation: {
    home: 'Home',
    verifyAccount: 'Verify My Account',
    contestLobby: 'Contest Lobby',
    myEntries: 'My Entries',
    myContests: 'My Contests',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    mySplashAccount: 'My Splash Account',
    commissioner: 'Commissioner',
    login: 'Log in',
    logout: 'Sign Out',
    createAContest: 'Create a Contest',
    referAFriend: 'Refer a Friend',
    myCommissionerChannel: 'Commissioner Channel',
    myCommissionerConsole: 'Commissioner Console',
    becomeACommissioner: 'Become a Commissioner',
    channel: 'My Channel',
  },
  balanceUnavailable: 'Balance Unavailable',
  balanceUpdate: {
    cash: 'Cash',
    cashBalance: 'Cash Balance',
    credits: 'Credits',
    creditsBalance: 'Credits Balance',
    balance: 'Balance',
    voucherApplied: `Unavailable\n(Voucher applied)`,
  },
  contest: {
    pickEm: "Pick'Em",
    survivor: 'Survivor',
    tiers: 'Tiers',
    oneAndDone: 'O&D',
    quickPicks: 'QuickPicks',
    playerSurvivor: 'Player Survivor',
    squares: 'Squares',
    targetScore: 'Target Score',
    wins: 'Wins',
    shares: 'Shares',
    brackets: 'Brackets',
    gameshell: {
      gameLog: 'Game log',
      entryAction: {
        edit: 'Edit Picks {{position}}',
        make: 'Make Picks {{position}}',
        view: 'View Picks {{position}}',
      },
      entries: 'ENTRIES',
      entryCount: {
        multi: 'MULTI-ENTRY ({{myEntriesCount}}/{{maxPerUser}})',
        single: 'SINGLE ENTRY',
      },
      prizePot: 'PRIZE POT',
      balance: 'BALANCE',
      addNewEntry: 'Add New Entry',
      enterNowAmount: 'ENTER NOW {{entryFee}}',
      deposit: 'Deposit',
      contestStart: 'CONTEST START',
      live: 'LIVE',
      contestStatus: 'CONTEST STATUS',
      makePicksBy: 'MAKE PICKS BY',
      editPicksBy: 'EDIT PICKS BY',
      final: 'FINAL',
      youFinishedThisSlateInPositionX: 'You finished this slate in {{nthPosition}}!',
      youFinishedInPositionX: 'You finished {{nthPosition}}!',
      slateStatus: {
        noPicks: 'Whoops, No Picks Were Made',
        regular: 'Slate {{status}}',
        over: 'Slate <strong>is Over</strong>',
        live: 'Slate <strong>is Live</strong>',
      },

      editPickSinglePlayer: 'Pick a Single Player From Each Tier',
      editTier: 'Edit <strong>Tier {{tier}}</strong>',
      pickTier: 'Pick <strong>Tier {{tier}}</strong>',
      entrySubmitted: 'Entry Submitted',
      picksSet: 'Your Picks <strong>Are Set</strong>',
      lookingGood: 'Looking Good!',
      confirm: 'Confirm <strong>Your Picks</strong>',
      pickSinglePlayer: 'Pick a Single Player From Each Tier',
      youAreCurrentlyInPositionX: 'You are currently {{nthPosition}}',

      pointsAbbr__hasPlural: {
        one: '1 FPT',
        other: '{{count}} FPTS',
      },
      discardChanges: 'Cancel Edit',
      submitPicks: 'Submit Picks',
      stat: {
        youWon: 'You won',
        winning: 'winning',
        position: 'position',
        score: 'score',
      },
      playerStats: {
        rank: 'RANK',
        top25s: 'TOP 25s',
        avg: 'AVG',
        score: 'SCORE',
        strokes: 'STROKES',
        round: 'ROUND',
        thru: 'THRU',
        yearsExperience: 'EXP',
        fppg: 'PROJ',
        team: 'TEAM',
        opposingTeam: 'OPP',
      },
      leaderboardPlayerStats: {
        score: 'SCORE',
        strokes: 'STROKES',
        round: 'ROUND',
        thru: 'THRU',
        passYards: 'PASS YDS',
        passTDs: 'PASS TDS',
        rushYards: 'RUSH YDS',
        recYards: 'REC YDS',
        recTDs: 'REC TDS',
        recRecs: 'REC',
        rushTDs: 'RUSH TDS',
      },
      noStatsFound: 'No stats found',
      remove: 'Remove',
      filled: 'Filled',
      select: 'Select',
      draft: 'Draft',
      contestLeaders: {
        noPicksEntry: 'This user has not made any picks yet',
        header: {
          rank: 'RK',
          username: 'Username',
          score: 'Score',
          total: 'Total',
        },
      },
    },
    contestRow: {
      entriesXofMax: 'Entries ({{userEntries}}/{{maxPerUser}})',
      entry: 'Entry',
      prizes: 'Prizes',
      enter: 'Enter',
      view: 'View',
    },
    invite: {
      cta: 'Invite',
    },
  },
  contestLobby: {
    title: 'Lobby',
    viewStyle: {
      table: 'Table View',
      grid: 'Grid View',
    },
    viewContest: 'View Contest Details',
    viewEntries: 'View My Entries',
    inviteEntrants: 'Invite Entrants',
    manageEntrants: 'Manage Entrants',
    addEntries: 'Add Entries',
    locationInfo: {
      title: 'Restricted Location',
      message:
        'Some contests may not be available in your current location. <link>Check our map</link> to view where you can play.',
    },
  },
  filters: {
    // NEW Dynamic Filter Component
    sortBy: {
      title: 'Sort by',
      options: {
        default: 'Default',
        contestName: 'Contest name (A-Z)',

        // My contests & Contest Lobby
        nextSlateStarting: 'Next slate starting soonest',
        recentlyEntered: 'Recently entered',
        highestEntryFee: 'Highest entry fee',
        lowestEntryFee: 'Lowest entry fee',
        highestTotalPrizes: 'Highest total prizes',

        // Commissioner
        entriesRemaining: 'Entries remaining',
        entryDeadlineDate: 'Entry deadline date',
        entryFee: 'Entry fee',
        totalPrizes: 'Total prizes',
        startDate: 'Start date',
        entrantsCount: 'Entrants count',
      },
    },
    gameType: {
      title: 'Game types',
      options: {
        all: 'All',
        team_survivor: 'Survivor',
        team_pick_em: "Pick'Em",
        player_tier: 'Tiers',
        player_one_and_done: 'One & Done',
        player_survivor: 'Player Survivor',
      },
    },
    status: {
      title: 'Status',
      options: {
        all: 'All',
        missingPicks: 'Missing picks',
        scheduled: 'Not yet started',
        inProgress: 'Started',
      },
    },
    hasEntryFee: {
      title: 'Entry type',
      options: {
        all: 'All',
        entryFee: 'Entry fee',
        noEntryFee: 'No entry fee',
      },
    },
    payoutFormats: {
      title: 'Payout formats',
      options: {
        all: 'All',
        topX: 'Top X',
        multiplier: 'Multiplier',
      },
    },
    entryTypes: {
      title: 'Entry types',
      options: {
        all: 'All',
        multiEntry: 'Multi Entry',
        singleEntry: 'Single Entry',
      },
    },
    entryFee: {
      title: 'Entry fee',
      options: {
        all: 'No limit',
        noEntryFee: 'No entry fee',
        tier1: '$1 - $10',
        tier2: '$11 - $100',
        tier3: '$101 - $1000',
        tier4: '$1001 - $10000',
      },
    },
    hideUnlisted: {
      title: 'Hide unlisted',
      options: {
        all: 'Hide unlisted',
        show: 'Show unlisted',
      },
    },
    viewStyle: {
      title: 'View as',
      options: {
        table: 'Table',
        grid: 'Grid',
      },
    },
  },
  footer: {
    responsibleGaming: {
      header: 'Responsible Gaming',
      commitment: 'Responsible Gaming Commitment',
      limits: 'Responsible Gaming Limits',
      policy: 'Responsible Gaming Policy',
      selfExclusion: 'Self-Exclusion',
      averageResults: 'Average Results',
      gamblingProblemBlurb:
        'If you or someone you know has a gambling problem, help is available. Call 1-800-GAMBLER',
      gamblingProblemTelephoneNumber: 'tel:+18004262537',
    },
    myAccount: {
      header: 'My Account',
      deposit: 'Deposit',
      withdrawal: 'Withdrawal',
      transactionHistory: 'Transaction History',
      accountSettings: 'Account Settings',
    },
    splashApps: {
      header: 'Splash Apps',
      iosApp: 'iOS',
      androidApp: 'Android',
      androidCanada: 'Android Canada',
    },
    whatsNew: {
      header: "What's New?",
      brandGuidelines: 'Brand Guidelines',
      commissionerRewards: 'Commissioner Rewards',
      whereCanIPlay: 'Where Can I Play?',
      gameRules: 'Game Rules',
    },
    company: {
      header: 'Company',
      terms: 'Terms of Use',
      privacyPolicy: 'Privacy Policy',
      cookiePolicy: 'Cookie Policy',
      faqs: 'FAQs',
      contactUs: 'Contact Us',
    },
  },
  /** @deprecated */
  mySplashAccount: 'My Splash Account',
  transactionHistory: 'Transaction History',
  accountSettings: 'Account Settings',
  commissionerCalculator: 'Commissioner Payout Calculator',
  withdraw: 'Withdraw',
  deposit: {
    title: 'Deposit',
    errors: {
      cardTypeNotSupportedTitle: 'Card type not supported',
      cardTypeNotSupportedMessage: 'The card type that you have entered is not currently supported',
      generalTitle: 'Deposit Error',
      generalMessage:
        'Your deposit could not be processed. Please make sure the information entered is correct and contact support if you think there is an issue.',
    },
  },
  withdrawal: {
    title: 'Withdrawal',
    fields: {
      amount: {
        label: 'Withdrawal Amount',
        placeholder: '$10.00',
      },
    },
    warnings: {
      cannotWithdrawToCreditCard:
        'For your security, we require a successful debit card deposit before withdrawing to a debit card. Please make a deposit or use one of our other withdrawal methods if you do not have a saved Debit Card.',
    },
    errors: {
      insufficientBalance: 'Insufficient balance',
    },
  },
  logout: 'Sign Out',
  verifyAccount: 'Verify My Account',
  header: {
    changeTheme: 'Change Theme',
    lobby: 'Lobby',
    deposit: 'Deposit',
  },
  copyContestLink: 'Copy Contest link',
  copyReferAFriendLink: {
    success: {
      message: 'Paste your link in an email or message and send to your friends!',
      title: 'Refer A Friend Link Copied!',
    },
    error: {
      message:
        'There was an issue generating your Refer a Friend link. Please contact Customer Support or try again later.',
      title: 'Refer A Friend Link Not Generated',
    },
  },
  quickPicksPromo: {
    titleMobile: 'Trending QuickPicks',
    subheading: 'Trending',
    heading: 'Quickpicks',
    bannerLine1: 'Choose up to 6 players, ',
    bannerLine2: 'Win up to 50x your entry',
  },
  joinNow: 'JOIN NOW',
  user: {
    common: {
      emailOrUsername: 'name@email.com OR username',
      yourNewPassword: 'Your new password',
      errors: {
        password: {
          tooShort: 'Password should include at least 8 characters',
          needsUppercase: 'Password should have at least one uppercase letter',
          needsLowercase: 'Password should have at least one lowercase letter',
          needsNumber: 'Password should have at least one number',
          needsSpecialCharacter: 'Password should have at least one special character',
        },
      },
    },
    kyc: {
      common: {
        contestLobby: 'Browse Contests',
        emailSupport: 'Email Support',
      },
      refer: {
        skip: 'Skip verification',
        idcomply: {
          title: 'Verify your identity',
          description:
            "We need to verify your identity with a photo ID. You'll be redirected to a secure verification form.",
          startVerification: 'Start Verification',
          verifyingTitle: 'Verifying your documents',
          verifyingDescription: "This may take a moment. Please don't close this page.",
          errorStartFailed: 'Could not start document verification. Please try again.',
          errorTimeout: 'Verification is taking longer than expected. You can try again.',
          errorRetry: 'Your verification could not be completed. Please try again.',
          errorTitle: 'Verification Error',
          incompleteTitle: 'Verification incomplete',
          timeoutTitle: 'Verification Timeout',
        },
      },
      accept: {
        title: 'Welcome to Splash!',
        copy: "You're almost there! Before you can enter any contests, you'll need to deposit",
        depositNow: 'Deposit Now',
        continueWithoutDeposit: 'Continue Without Deposit',
      },
      reject: {
        title: 'There was an issue verifying your information.',
        copy: 'Your information could not be verified automatically. Please contact our support team for manual review.',
      },
      resubmit: {
        title: 'Max Resubmissions Reached',
        copy: "You've reached the maximum number of address verification attempts.",
        copy2: "Don't worry! We have a few other options for you:",
        uploadDocuments: 'Upload Documents',
      },
      review: {
        title: 'Your information needs review',
        copy: 'Please contact our support team for further details on verifying your account.',
      },
      policy: {
        title: 'Your data is encrypted and secure.',
        subtitle:
          'To ensure legal compliance, information about your identity, location, and age is required.',
      },
    },
  },
  commissionerCTA: {
    nonCommissionerCopy: 'Become a Commissioner!',
    commissionerCopy: 'My Commissioner Channel',
  },
  errors: {
    actions: {
      reload: 'Reload the page',
      takeMeHome: 'Take me home',
      logInOrSignUp: 'Log in or Sign up',
    },
    BAD_REQUEST: {
      title: 'Bad Request',
      body: 'The request could not be understood by the server due to malformed syntax.',
    },
    UNAUTHORIZED: {
      title: 'Unauthorized',
      body: 'You need to be logged in to access this resource. Please sign in and try again.',
    },
    FORBIDDEN: {
      title: 'Forbidden',
      body: "You don't have permission to access this resource. Please contact support if you believe this is an error.",
    },
    NOT_FOUND: {
      title: 'Not Found',
      body: 'The requested resource could not be found.',
    },
    INTERNAL_SERVER_ERROR: {
      title: 'Something went wrong',
      body: "Our servers could not handle your request. Don't worry, our development team was already notified. Try refreshing the page.",
    },
    USER_NOT_AUTHORIZED: {
      title: 'Unauthorized',
      body: 'Please log in.',
    },
    KYC_ALREADY_APPROVED: {
      title: "You've already verified your identity",
      body: 'Go to the contest lobby to check out our contests!',
    },
    KYC_ID_REFERRED: {
      title: 'We need more information',
      body: '',
    },
    KYC_MANUAL_REVIEW: {
      title: 'We need more information to verify your identity',
      body: 'Please contact support if you are having any issues.',
    },
    KYC_REJECTED: {
      title: 'We are unable to verify your identity',
      body: 'Please contact support if you believe there is an issue.',
    },
    ACTIVE_TIMEOUT_EXISTS: {
      title: 'Timeout already applied',
      body: "You've already opted into a timeout.",
    },
    USER_ALREADY_EXISTS: {
      title: 'Duplicate Account',
      body: 'It appears you already have another account. Please contact support for details. ',
    },
    USER_NOT_KYC_APPROVED: {
      title: 'Please verify your identity.',
      body: 'Before you are able to deposit or enter a contest, you must finish verifying your identity.',
    },
    INVALID_USER_STATUS: {
      title: 'Please verify your identity.',
      body: 'Before you are able to deposit or enter a contest, you must finish verifying your identity.',
    },
    USER_NOT_FOUND: {
      title: "We're having an issue",
      body: 'Please refresh and try again.',
    },
    LOCATION_ERROR: {
      title: 'Invalid Location',
      body: 'We are not yet active in your current location.',
    },
    ACTIVE_TIMEOUT: {
      title: 'Timeout on account',
      body: 'There is an active timeout on your account.',
    },
    generic: {
      kyc: 'Verification Error',
      invalidX: 'Invalid {{value}}',
    },
    unknown: {
      title: 'Unknown Error. Please try again.',
    },
  },
  modal: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
  },
  modals: {
    sportStyleChange: {
      league: {
        title: 'Switching league will reset your setup',
        description:
          "Changing the league will reset your setup. You'll need to select a contest template and configure your contest again from the beginning.",
      },
      contestType: {
        title: 'Switching contest type will reset your setup',
        description:
          "Changing the contest type will reset your setup. You'll need to configure your contest again from the beginning.",
      },
      confirmLabel: 'Yes, change it',
      cancelLabel: 'Cancel',
    },
  },
  invites: {
    modal: {
      title: 'Invite members',
      contests: 'Contests',
      xContests: '{{value}} Contests',
      shareViaLink: 'Share via link',
      copyLink: 'Copy link',
      searchMembers: 'Search members',
      people: 'People',
      users__hasPlural: {
        zero: 'Users',
        one: 'User',
        other: 'Users ({{count}})',
      },
      all: 'All',
      addViaEmail: 'Add via email',
      previousContests: 'Previous Contests',
      addAll: 'Add all',
      added: 'Added',
      noContestsFound: 'No contests found',
      noUsersFound: 'No users found',
      members__hasPlural: {
        one: '1 entry',
        other: '{{count}} entries',
      },
      emails__hasPlural: {
        zero: 'Emails',
        one: 'Emails (1)',
        other: 'Emails ({{count}})',
      },
      splashInvites__hasPlural: {
        zero: 'Splash Users',
        one: 'Splash Users (1)',
        other: 'Splash Users ({{count}})',
      },
      rypInvites__hasPlural: {
        zero: 'RYP Users',
        one: 'RYP Users (1)',
        other: 'RYP Users ({{count}})',
      },
      rypPools__hasPlural: {
        zero: 'RYP Contests',
        one: 'RYP Contests (1)',
        other: 'RYP Contests ({{count}})',
      },
      ofpInvites__hasPlural: {
        zero: 'OFP Users',
        one: 'OFP Users (1)',
        other: 'OFP Users ({{count}})',
      },
      ofpPools__hasPlural: {
        zero: 'OFP Contests',
        one: 'OFP Contests (1)',
        other: 'OFP Contests ({{count}})',
      },
      splashContests__hasPlural: {
        zero: 'Splash Contests',
        one: 'Splash Contests (1)',
        other: 'Splash Contests ({{count}})',
      },
      selected__hasPlural: {
        zero: 'None Selected',
        one: '{{count}} Selected',
        other: '{{count}} Selected',
      },
      splash: 'Splash',
      runyourpool: 'RunYourPool',
      officefootballpool: 'OfficeFootballPool',
      linkEOCTA: {
        copy: 'Link your <eoSite/> account to invite your connections. <link/>',
        linkNow: 'Link now',
      },
      loadMore: 'Load more...',
      usersEmptyState: "Add users via email or start with a previous contest you've run",
      noConnectedMembersFound: 'No connected members found.',
      selectedEmptyState: 'Click on members to add them to the invite list',
      emailOnlyEmptyState: "Add your friends' emails to invite them to Splash",
      xSelected: '{{count}} Selected',
      selected: 'Selected',
      selectedRYPUsers: 'Selected RYP Users',
      unselectAll: 'Unselect All',
      removeAll: 'Remove All',
      sendInvites: 'Send Invites',
      inviteViaEmail: {
        title: 'Invite via email',
        subTitle:
          "Got a friend who's not on Splash yet? Invite them via email. You can paste up to 2,000 emails.",
        label: 'Email Address',
        placeholder: 'name1@email.com, name2@email.com, name3@email.com, name5@email.com...',
        add: 'Add',
        disclaimer: 'Your friend will receive a contest invite with an auto-generated message.',
      },
      success: {
        title: 'Invites Sent',
        message__hasPlural: {
          one: 'Your invite will be going out shortly!',
          other: 'Your {{count}} invites will be going out shortly!',
        },
      },
      error: {
        title: 'Error Sending Invites',
        message: 'Your invites could not be sent.',
      },
    },
  },
  cancelContest: {
    cancel: 'Cancel Contest',
    tooltip: 'Contests with entries cannot be cancelled',
    success: "'{{name}}' cancelled successfully!",
    error: {
      title: 'Contest Cancel Error',
      message: "There was an issue cancelling your '{{name}}' contest",
    },
  },
  newToSplash: {
    joinThisContest: 'Join this contest',
    joinThisContestSeasonPayout:
      'Join this contest, now with <br/> <link>In-Season Payouts</link> !',
    title: 'New to Splash?',
    signUp: 'Sign up',
    logIn: 'Log in',
    loginOrSignup: 'Log in or Sign up',
    termsAndPrivacy:
      'By signing up, you agree to the <termsLink>Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>, including <cookiesLink>Cookie Use</cookiesLink>.',
    contestTypeAvailability:
      'Click <link>here</link> to see which contest types are available in each state.',
  },
  getEmailListIntercom:
    'I would like to communicate with the players in my contest! Can you give me access to their contact information? I agree to the terms and conditions for contacting these players',
  banner: {
    newAppVersion: {
      title:
        'Update available! <link>Refresh this page</link> for the latest and greatest version of Splash Sports.',
      titleMobile: 'Update available!',
    },
    geoLocationPrompted: {
      messageDesktop:
        '<prefixText/> Please share your location via the browser site settings. <link>Need help?</link>',
      messageMobile: '<prefixText/> Please share your location. <link>Need help?</link>',
      prefix: 'Action required!',
    },
    userExcluded: {
      messageDesktop:
        'Per your request, your account has been placed on a self-imposed timeout. During the timeout period, you will be unable to make deposits or enter contests. For more information, please see our <link>Responsible Gaming policy</link>.',
      messageMobile:
        'Your account has been placed on a self-imposed timeout. During the timeout period, you will be unable to make deposits or enter contests. For more information, please see our <link>Responsible Gaming policy</link>.',
    },
    userLocked: {
      messageDesktop:
        'Your account is currently disabled. If you believe this is in error, please <link>contact customer support</link>.',
      messageMobile:
        'Your account is currently disabled. If you believe this is in error, please <link>contact customer support</link>.',
    },
    underLegalAge: {
      messageDesktop:
        'It appears you are under the legal age for entering contests in your jurisdiction. You must be at least {{requiredAge}} years of age to play in {{state}}.',
      messageMobile:
        'It appears you are under the legal age for entering contests in your jurisdiction. You must be at least {{requiredAge}} years of age to play in {{state}}.',
    },
    duplicateAccount: {
      prefix: 'Duplicate account detected!',
      messageDesktop:
        '<prefixText/> Based on your name and address, it appears you may have more than one account. If you have already registered with a different email, please log in using those credentials. If you need further assistance, please <link>contact customer support</link>.',
      messageMobile:
        '<prefixText/> Based on your name and address, it appears you may have more than one account. If you have already registered with a different email, please log in using those credentials. If you need further assistance, please <link>contact customer support</link>.',
    },
    locationCheckFailed: {
      prefix: 'Location verification issue!',
      messageDesktop:
        '<prefixText/> We are unable to verify your location at this time. Contest availability may be impacted. Please make sure you are sharing your location via the browser site settings. <link>Need help?</link>',
      messageMobile:
        '<prefixText/> We are unable to verify your location at this time. Contest availability may be impacted. Please make sure you are sharing your location via the browser site settings. <link>Need help?</link>',
    },
    locationDenied: {
      prefix: 'Location not eligible:',
      messageDesktop:
        '<prefixText/> It appears you are currently in a location that we do not yet service. Click here for a list of <link>eligible locations</link>.',
      messageMobile:
        '<prefixText/> It appears you are currently in a location that we do not yet service. Click here for a list of <link>eligible locations</link>.',
    },
    verificationBanner: {
      prefix: 'Action required!',
      messageDesktop:
        '<prefixText/> Account verification must be completed to play on Splash Sports.',
      messageMobile:
        '<prefixText/> Account verification must be completed to play on Splash Sports.',
      cta: 'Verify now',
    },
    maintenanceBanner: {
      message: 'We are currently performing maintenance on our site. We will be back shortly.',
    },
  },
  appShellHeader: {
    balance: 'Balance',
    contestLobby: 'Contest Lobby',
    createAContest: 'Create a Contest',
    deposit: 'Deposit',
    home: 'Home',
    myAccount: 'My Splash Account',
    myChannel: 'My Channel',
    myContests: 'My Contests',
    entries: 'Entries',
    signOut: 'Sign Out',
    verifyUser: 'Verify User',
    withdraw: 'Withdraw',
    referAFriend: 'Refer a Friend',
    logIn: 'Log in',
    quickPicks: 'QuickPicks',
    commissioner: 'Commissioner',
  },
  appShellHeader3: {
    nav: {
      home: 'Home',
      lobby: 'Lobby',
      quickPicks: 'QuickPicks',
      myContests: 'My Contests',
      commissioner: 'Commissioner',
      predictionMarkets: 'Predict',
      entryMarketplace: 'Entry Marketplace',
    },
    subNav: {
      active: 'Active',
      final: 'Final',
      invites: 'Invites',
    },
    userWidget: {
      cacLabel: 'Create contest',
      authLabel: 'Log in or Sign up',
      authLabelMobile: 'Log in',
    },
    userMenu: {
      home: 'Home',
      contestLobby: 'Lobby',
      myContests: 'My Contests',
      quickPicks: 'QuickPicks',
      markets: 'Predict',
      entryMarketplace: 'Entry Marketplace',
      commissioner: 'Commissioner',
      deposit: 'Deposit',
      withdraw: 'Withdraw',
      notifications: 'Notifications',
      promotions: 'Promotions',
      inviteFriends: 'Invite & Earn {{amount}}',
      myAccount: 'My Account',
      helpCenter: 'Help Center',
      signOut: 'Sign Out',
      logIn: 'Log in',
    },
  },
  table: {
    noData: 'No data',
    emptyState: 'No data available',
    pagination: {
      range: '{{fromIndex}}-{{toIndex}}',
      ofTotalUnits: 'of {{total}} {{unit}}',
      ofTotalUnitsMobile: 'of {{total}}',
      perPage: '{{unit}} per page: ',
    },
  },
  support: {
    vipSupport: 'VIP Support',
    contactSupport: 'Contact Support',
    emailSubject: 'Error Message: "{{title}}"',
    emailBody: 'I received the following error message: "{{message}}"',
  },
  welcomeModal: {
    myContests: {
      title: {
        ryp: 'Your RYP contests are here now',
        ofp: 'Your OFP contests are here now',
        combo: 'Your contests are here now',
      },
      description: 'Pick up right where you left off.',
      actionButtonText: 'Got it',
    },
    firstLogin: {
      title: 'Welcome to Splash!',
      description:
        'We’ve brought over your contests (previously known as pools). Here’s where to find them in your new app.',
      actionButtonText: 'Take me to my contests',
    },
  },
  proveSuccess: {
    title: "You're all set on your mobile device!",
    description:
      "We've confirmed the link on your mobile device. To finish verifying your identity, please return to your desktop browser and continue in that window.",
    subText: 'You can now close this tab on your phone.',
  },
};
